/**
 * Adunarea marfii proprii pe produs, pentru fișa de costuri a unei activități.
 *
 * DE CE: la un eveniment, același produs iese pe zeci de bonuri separate, câte unul de fiecare
 * bucată. În listă se vedea „1 × 53,71" de treizeci de ori la rând — un zid din care nu afli nici
 * câte bucăți au ieșit, nici cât au costat (Alexandru, 18.09.2026).
 *
 * Gruparea nu e doar o ascundere a rândurilor: e chiar informația pe care cineva o caută acolo.
 * Detaliul pe bonuri rămâne la un click.
 */

export interface RandMarfa {
  /**
   * De ce acțiune de teren ține rândul.
   *
   * Marfa predată o știe singură, din predare — nu se alege și nu se mută. Câmpul e aici doar ca
   * ecranul de costuri să poată filtra pe acțiune fără să știe din ce sursă vine cifra.
   */
  actiuneId: number | null
  actiuneDenumire: string | null
  bonDocNo: string
  sku: string
  denumire: string
  cantitate: number
  pret: number | null
  valoare: number | null
  estimat: boolean
  diferentaMare: boolean
}

export interface GrupMarfa {
  sku: string
  denumire: string
  cantitate: number
  /** Suma rândurilor care AU preț. Cele fără preț se numără separat, în `faraPret`. */
  valoare: number
  /** Pe câte bonuri diferite a ieșit produsul. */
  bonuri: number
  faraPret: number
  /** Măcar un rând are preț de la emitere, neconfirmat din ExpertAccounts. */
  estimat: boolean
}

/** Câte rânduri se arată întregi, fără să fie nevoie de un click. */
export const PRAG_MARFA_PLIATA = 6

export function grupeazaMarfa(randuri: RandMarfa[]): GrupMarfa[] {
  const m = new Map<string, GrupMarfa>()
  for (const r of randuri) {
    // SKU-ul e cheia; denumirea e rezerva, pentru rândurile fără cod.
    const cheie = r.sku || r.denumire
    const g = m.get(cheie) ?? {
      sku: r.sku,
      denumire: r.denumire,
      cantitate: 0,
      valoare: 0,
      bonuri: 0,
      faraPret: 0,
      estimat: false,
    }
    g.cantitate += r.cantitate
    /*
      Rândurile fără preț NU intră în sumă și nu se aproximează. Un preț inventat ar face totalul
      să pară complet — și nimeni n-ar mai căuta ce lipsește.
    */
    if (r.valoare == null) g.faraPret += 1
    else g.valoare += r.valoare
    g.bonuri += 1
    if (r.estimat) g.estimat = true
    m.set(cheie, g)
  }
  // Cele scumpe primele: acolo se uită omul întâi.
  return [...m.values()].sort((a, b) => b.valoare - a.valoare)
}
